import "./HeadingItem.scss";

import { SortButton } from "@mercdev.com/mercurial-ui/controls";
import { SortDirection } from "api/links";
import cn from "classnames";
import { useEffect, useState } from "react";
import { useLinkStore } from "stores/LinkListStore";
import { getOrderString, setStringToOrder } from "utils/getOrderString";

import { ILink } from "/@types";

import { linkPropertyToSortBy } from "../../properties";

interface IProps {
  className?: string;
  property: keyof ILink;
  title: string;
}

export const HeadingItem = ({ className, property, title }: IProps) => {
  const [orderBy, setOrderBy] = useLinkStore((state) => [
    state.orderBy,
    state.setOrder,
  ]);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState<SortDirection>(
    SortDirection.asc
  );

  useEffect(() => {
    if (orderBy) {
      setSortBy(Object.keys(setStringToOrder(orderBy))[0]);
      setSortDirection(
        Object.values(setStringToOrder(orderBy))[0] as SortDirection
      );
    }
  }, [orderBy]);

  const onSortHandle = (property: keyof ILink) => {
    setOrderBy(
      getOrderString([
        {
          key: linkPropertyToSortBy[property],
          value:
            sortDirection === SortDirection.asc
              ? SortDirection.desc
              : SortDirection.asc,
        },
      ])
    );
  };

  return (
    <li className={cn(className, "heading-item")}>
      <div className="heading-item-inner">
        <SortButton
          label={title}
          isActive={sortBy === linkPropertyToSortBy[property]}
          onClick={() => onSortHandle(property)}
          direction={sortDirection}
        />
      </div>
    </li>
  );
};
